import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { GenericUploadComponent } from './generic-upload.component';

@NgModule({
  declarations: [GenericUploadComponent],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  exports: [GenericUploadComponent],
})
export class GenericUploadModule {}
